import { render, staticRenderFns } from "./WorkshopList.vue?vue&type=template&id=55a552ee&"
import script from "./WorkshopList.vue?vue&type=script&lang=js&"
export * from "./WorkshopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports